/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_All_Event_GroupsInputs */



/**
* | output |
* | --- |
* | "Apply to All Event Groups" |
*
* @param {Apply_To_All_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all_event_groups = /** @type {((inputs?: Apply_To_All_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_All_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer à tous les groupes d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gilt für alle Veranstaltungsgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica a tutti i gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить ко всем группам мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar a todos los grupos de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("适用于所有活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのイベントグループに適用")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी इवेंट समूहों पर लागू होता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar a todos os grupos de eventos")
	return /** @type {LocalizedString} */ ("Apply to All Event Groups")
});